import React from "react";
import "pages/Contact/ContactPage.scss";
import ContactInfo from "components/reusable/ContactInfo/ContactInfo";

import { useLocation } from "react-router-dom";
import { getQueries } from "api/wagtailAdapter";
import { usePagesApiParser } from "services/hooks/PagesAPIParser";
import Head from "components/reusable/Head/Head";
import Breadcrumbs from "components/Breadcrumbs/Breadcrumbs";
import ContactBlock from "components/Contact/ContactBlock"

const Location = ({ title, address1, address2 }) => {
  return (
    <div tabIndex="0">
      <h4>{title}</h4>
      <p>{address1}</p>
      <p>{address2}</p>
    </div>
  );
};

export const TestContactSection = () => {
  const query = getQueries(useLocation().search).useGetTestContactPageQuery({
    queryParams: useLocation().search,
    localePath: useLocation().pathname.split("/")[1],
    region: useLocation().pathname.split("/")[2],
  });

  const info = query.data?.items ? query.data?.items[0] : query.data;

  return (
    <div>
      <ContactInfo
        title={info?.contact_us_header}
        description={info?.contact_us_body}
        badges={info?.contact_us}
      />
    </div>
  );
};

const ContactPage = () => {
  const { page: info } = usePagesApiParser(
    getQueries(useLocation().search).useGetContactPageQuery({
      queryParams: useLocation().search,
      localePath: useLocation().pathname.split("/")[1],
      region: useLocation().pathname.split("/")[2],
    })
  );

  return (
    <div>
      <Head
        title={
          useLocation().pathname.split("/")[1] === "fr" ?
            "Nous contacter | Beanfield" :
            "Contact Us | Beanfield"
        }
        description={
          useLocation().pathname.split("/")[1] === "fr" ?
            "Contactez l'équipe Beanfield à tout moment. Que ce soit par téléphone ou par courriel, nous serions ravis d'avoir de vos nouvelles." :
            "Reach out to the Beanfield Team anytime. Whether through phone or email, we'd love to hear from you."
        }
        imageName={"Contact"}
        locale={useLocation().pathname.split("/")[1]}
      />
      <div className="resi-container">
        <Breadcrumbs route={"contact-us"}></Breadcrumbs>
      </div>
      <div className="resi-container">
        <div className="resi-margin-container">
          <div className="contact-header" tabIndex="0">
            <h2>{info?.main_header}</h2>
            <p>{info?.main_description}</p>
          </div>
        </div>
      </div>

      {info?.contact_blocks?.length > 0 && info.contact_blocks.map((block, index) => {
        return (
          <ContactBlock
            image={block.image}
            title={block.title}
            subContactBlock={block.sub_contact_block}
            key={index}
          />
        )
      })}

      {info?.contact_section_page?.badges?.length > 0 && (
        <ContactInfo badges={info.contact_section_page.badges}/>
      )}
      {(info?.locations_header || info?.locations.length > 0) ? (
        <div className="resi-container">
          <div className="resi-margin-container">
            <div className="contact-location-container">
              <h3 tabIndex="0">{info?.locations_header}</h3>

              <div className="contact-location">
                {info?.locations?.map((location, index) => {
                  return (
                    <div key={index}>
                      <Location
                        title={location.title}
                        address1={location.address_1}
                        address2={location.address_2}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ContactPage;
